import { Project } from "@/types";
import { useQuery } from "@tanstack/react-query";
import { getOptionGroupFilterData } from "./optionGroups.api";
import { optionGroupKeys } from "./optionGroups.queryKeys";

export const useFilterOptionGroups = (projectId?: Project["id"]) => {
    return useQuery({
        queryKey: projectId ? optionGroupKeys.filterData(projectId) : optionGroupKeys.root,
        queryFn: () => getOptionGroupFilterData(projectId!),
        enabled: !!projectId,
    });
};
